require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/core-js/library/fn/is-iterable.js
// module id = ../../../../core-js/library/fn/is-iterable.js
// module chunks = 4